import { Shield, Eye, FileCheck, Newspaper } from 'lucide-react';
import { IntelligenceItem } from '../molecules/IntelligenceItem';

interface IntelligenceGridProps {
  breachHistoryCount: number;
  darkWebChatterCount: number;
  complianceCount: number;
  newsCount: number;
  onBreachHistoryClick?: () => void;
  onDarkWebChatterClick?: () => void;
  onComplianceClick?: () => void;
  onNewsClick?: () => void;
  className?: string;
}

export const IntelligenceGrid = ({
  breachHistoryCount,
  darkWebChatterCount,
  complianceCount,
  newsCount,
  onBreachHistoryClick,
  onDarkWebChatterClick,
  onComplianceClick,
  onNewsClick,
  className = '',
}: IntelligenceGridProps) => {
  return (
    <div
      className={`grid grid-cols-2 gap-4 w-full ${className}`}
      role="group"
      aria-label="Intelligence Summary"
    >
      <IntelligenceItem
        icon={<Shield size={16} />}
        label="Breach History"
        count={breachHistoryCount}
        onClick={onBreachHistoryClick}
      />
      <IntelligenceItem
        icon={<Eye size={16} />}
        label="Dark Web Chatter"
        count={darkWebChatterCount}
        onClick={onDarkWebChatterClick}
      />
      <IntelligenceItem
        icon={<FileCheck size={16} />}
        label="Compliance"
        count={complianceCount}
        onClick={onComplianceClick}
      />
      <IntelligenceItem
        icon={<Newspaper size={16} />}
        label="News"
        count={newsCount}
        onClick={onNewsClick}
      />
    </div>
  );
};
